import React, { useEffect } from "react";
import io from "socket.io-client";
import Sidebar from "../Common/Sidebar";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";
const Layout = ({ children }) => {
  // const token = localStorage.getItem("Token");
  // console.log(token, "Token Is ");
  const userId = localStorage.getItem("Token");

  useEffect(() => {
    const socket = io(
      BACKEND_BASE_URL
      // , {
      //   query: { token: userId },
      // }
    );
    console.log("-------------", socket);
    // const staticId = "6570077f2c645fd64c38b9cf"; // Set your static ID here

    socket.emit("join", {
      userid: userId,
    });
    // console.log("Join event emitted with static ID:", userId);

    socket.on("connect", () => {
      console.log("Socket connected");
    });

    // Listen for task update messages
    socket.on("new_todo_message", (message) => {
      console.log("layout new message,------------------------------", message);
      toast.success(message?.message); // Trigger toast notification
    });

    return () => {
      socket.disconnect(); // Clean up socket connection on component unmount
      console.log("Socket disconnected on component unmount");
    };
  }, []);

  return (
    <>
      <div className={`flex `}>
        <div className={`w-0 xl:w-[14.5%]`}>
          <Sidebar />
        </div>
        <div className="container w-full lg:w-[55%] xl:w-[85%] xl:mr- mx-10">
          {children}
          {/* <div className="h-full mx-auto lg:w-[95%]  w-full z-8  ">
          </div> */}
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      {/* <>
        <div className="flex">
          <div className="">
            <div className="lg:block hidden">
              <Sidebar />
            </div>
          </div>
          <div className=" w-0  lg:w-[25%] xl:w-[10%] lg:hidden"> */}
      {/* <Sider />  */}
      {/* </div>
          <div className="w-full lg:w-[75%] xl:w-[90%]  mx-5 container ">
            <div className="h-full ">{children}</div>
          </div>
        </div>
      </> */}
    </>
  );
};

export default Layout;
